import { Handle, Position } from 'reactflow'

const RuleNodeHandle = ({ target }) => {
  const handleSize = '0.6rem'

  return (
    <Handle
      id='end'
      type={target ? 'target' : 'source'}
      position={target ? Position.Up : Position.Bottom}
      style={{ width: handleSize, height: handleSize }}
      isConnectable={false}
    />
  )
}

export default RuleNodeHandle
